import React, { useState } from 'react';
import Container from 'shared/container';
import axios from 'axios';
import Headline from 'shared/headline';
import Input from 'shared/form-input';
import Button from 'shared/button';
import { useFormInput, useErrors, useSubmitReady } from 'hooks/useForm';
import s from './collab.module.scss';

function Form({ influencer }) {
  const [success, setSuccess] = useState(false);

  const name = useFormInput('');
  const email = useFormInput('');
  const company = useFormInput('');
  const website = useFormInput('');
  const message = useFormInput('');

  const nameErrors = useErrors({ name: name.state });
  const emailErrors = useErrors({ email: email.state });
  const companyErrors = useErrors({ company: company.state });
  const websiteErrors = useErrors({ website: website.state });
  const messageErrors = useErrors({ message: message.state });

  const resetForm = () => {
    name.setters.setValue('');
    name.setters.setTouched(false);
    name.setters.setBlurred(false);

    email.setters.setValue('');
    email.setters.setTouched(false);
    email.setters.setBlurred(false);

    company.setters.setValue('');
    company.setters.setTouched(false);
    company.setters.setBlurred(false);

    website.setters.setValue('');
    website.setters.setTouched(false);
    website.setters.setBlurred(false);

    message.setters.setValue('');
    message.setters.setTouched(false);
    message.setters.setBlurred(false);
  };

  const submitReady = useSubmitReady({
    name: name.state,
    email: email.state,
    company: company.state,
    website: website.state,
    message: message.state
  });

  const handleSubmit = async e => {
    e.preventDefault();
    const payload = {
      name: name.state.value,
      influencer,
      email: email.state.value,
      company: company.state.value,
      website: website.state.value,
      message: message.state.value
    };
    resetForm();
    try {
      const res = await axios.post(
        'https://furlough-main.firebaseio.com/influencer-inquiry.json',
        payload
      );
      setSuccess(true);
      console.log(res);
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <div className={s.formWrapper}>
      <form className={s.row} onSubmit={handleSubmit}>
        <div className={s.formflex}>
          <div className={s.inputs}>
            <Input
              {...name.events}
              error={nameErrors.name}
              required
              placeholder="Name"
              type="text"
              dark
              value={name.state.value}
            />
            <Input
              {...email.events}
              error={emailErrors.email}
              required
              name="email"
              placeholder="Email"
              type="text"
              dark
              value={email.state.value}
            />
            <Input
              {...company.events}
              error={companyErrors.company}
              required
              dark
              placeholder="Company"
              type="text"
              value={company.state.value}
            />
            <Input
              {...website.events}
              error={websiteErrors.website}
              dark
              required
              placeholder="Website"
              type="text"
              value={website.state.value}
            />
          </div>
          <div className={s.textAreaWrapper}>
            <Input
              {...message.events}
              required
              textarea
              dark
              error={messageErrors.message}
              placeholder="Message"
              value={message.state.value}
            />
          </div>
        </div>
        <Button disabled={!submitReady} type="submit">
          Contact
        </Button>
      </form>
    </div>
  );
}

function WantToCollabSection({
  influencer_name,
  price_high,
  price_low,
  ...props
}) {
  return (
    <Container className={s.root}>
      <Headline title h1 html="want to collab?" />
      <div className={s.contentWrapper}>
        <span className={s.subtitle}>
          Estimated post price based off standard inquiries
        </span>
        <div className={s.priceContainer}>
          <span className={`${s.price} ${s.red} `}>
            {`$${Number(price_low).toLocaleString()}`}
          </span>
          <span className={s.priceTo}>to</span>
          <span className={`${s.price} ${s.green} `}>
            {`$${Number(price_high).toLocaleString()}`}
          </span>
        </div>
        <Form influencer={influencer_name} />
      </div>
    </Container>
  );
}
export default WantToCollabSection;
